/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { memo } from 'react';
import Styles from '../css/AmortizationSchedulePage.module.css';
import AmortizationScheduleForm from '../components/forms/AmortizationScheduleForm';
import { AmortizationScheduleProvider } from '../contexts/AmortizationScheduleContext';
import { useLoanContext } from '../contexts/LoanContext';
import * as constants from '../common/constants';

const AmortizationSchedulePage = () => {
  const { loanHeloc } = useLoanContext();
  if (loanHeloc) {
    return <section className='access-error-msg'>{constants.helocErrorMsg}</section>;
  } else {
    return (
      <AmortizationScheduleProvider>
        <section className={Styles.page}>
          <AmortizationScheduleForm />
        </section>
      </AmortizationScheduleProvider>
    );
  }
};

export default memo(AmortizationSchedulePage);
